// Podaci konferencije 2026. — izvor: Poziv za sudjelovanje i upute za autore HR 2026.
// Svi datumi i informacije o aktualnom izdanju drže se ovdje kako bi se sljedeće godine mijenjali na jednom mjestu.

export const EVENT = {
    name: 'PR, Media & Sports Days University of Mostar',
    // Countdown odbrojava do početka konferencije (Mostar, CET)
    start: '2026-11-11T00:00:00+01:00',
    end: '2026-11-13T23:59:59+01:00',
    // Google/ICS: cjelodnevni događaj, završni datum je isključiv
    calendarStart: '20261111',
    calendarEnd: '20261114',
    location: 'Filozofski fakultet Sveučilišta u Mostaru, Matice hrvatske b. b., 88000 Mostar, BiH',
    email: 'prdays@ff.sum.ba',
    phone: '+387 (0)36 355 410',
    web: 'https://prdays.sum.ba',
    journalUrl: 'https://seejc.sum.ba',
    hashtag: '#PRMediaAndSportsDays',
    // Postaviti kad budu dostupni
    programUrl: '',
    livestreamUrl: '',
    callPdf: '/documents/PRMSD-2026-poziv-i-upute-za-autore-HR.pdf',
};

export default {
    hr: {
        eyebrow: 'Jedanaesto izdanje · Mostar',
        conference_type: 'Međunarodna znanstveno-stručna konferencija',
        date: '11.–13. studenoga 2026.',
        date_short: '11.–13. 11. 2026.',
        theme_label: 'Tema konferencije',
        theme: 'PR 4.0 – Organizacija, upravljanje i komunikacija',
        theme_short: 'Organizacija, upravljanje i komunikacija',
        intro: 'U organizaciji Studija odnosa s javnošću i Studija novinarstva Filozofskoga fakulteta Sveučilišta u Mostaru, od 11. do 13. studenoga 2026. održat će se jedanaesto izdanje međunarodne znanstveno-stručne konferencije „PR, Media & Sports Days University of Mostar”.',
        focus: 'Poseban naglasak stavlja se na interdisciplinarni pristup komunikaciji kao strateškom resursu organiziranja, upravljanja i vođenja organizacija, medija, javnih institucija, poslovnih sustava i sportskih organizacija u suvremenom digitalnom, globalnom i međusobno povezanom okruženju.',
        calendar_google: 'Dodaj u Google kalendar',
        calendar_details: 'Jedanaesto izdanje međunarodne znanstveno-stručne konferencije. Tema: PR 4.0 – Organizacija, upravljanje i komunikacija. Više informacija: https://prdays.sum.ba',
        countdown_title: 'Do početka konferencije',
        countdown_units: ['Dana', 'Sati', 'Minuta', 'Sekundi'],
        countdown_live: 'Konferencija je u tijeku!',
        countdown_done: 'Hvala svima na sudjelovanju!',
        program_download: 'Preuzmite program konferencije',
        program_soon: 'Program konferencije bit će objavljen uskoro.',
        call_download: 'Poziv i upute za autore (PDF)',
        send_abstract: 'Pošaljite sažetak',

        dates_title: 'Važni datumi',
        dates_groups: [
            {
                title: 'Prijava izlaganja',
                items: [
                    {date: '19. listopada 2026.', label: 'Rok za slanje sažetaka'},
                    {date: '26. listopada 2026.', label: 'Obavijest o prihvaćanju prijava'},
                    {date: '2. studenoga 2026.', label: 'Rok za slanje PowerPoint prezentacija'},
                    {date: '11.–13. studenoga 2026.', label: 'Održavanje konferencije', highlight: true},
                ],
            },
            {
                title: 'Cjeloviti radovi (SEEJC)',
                items: [
                    {date: '26. listopada 2026.', label: 'Rok za slanje cjelovitih radova'},
                    {date: '15. studenoga 2026.', label: 'Obavijest o prihvaćanju cjelovitih radova'},
                ],
            },
        ],

        facts_title: 'Konferencija u brojkama i činjenicama',
        facts: [
            {icon: 'mdi-numeric', label: 'Izdanje', value: 'Jedanaesto izdanje'},
            {icon: 'mdi-translate', label: 'Radni jezici', value: 'Hrvatski i engleski'},
            {icon: 'mdi-timer-outline', label: 'Trajanje usmenog izlaganja', value: 'Najviše 15 minuta'},
            {icon: 'mdi-email-outline', label: 'Prijave i sažeci', value: 'prdays@ff.sum.ba', href: 'mailto:prdays@ff.sum.ba'},
            {icon: 'mdi-web', label: 'Mrežna stranica', value: 'prdays.sum.ba', href: 'https://prdays.sum.ba'},
            {icon: 'mdi-book-open-page-variant-outline', label: 'Objava cjelovitih radova', value: 'South Eastern European Journal of Communication (SEEJC)', href: 'https://seejc.sum.ba'},
        ],
        sections_label: 'Program / sekcije',
        sections: ['Odnosi s javnošću', 'Mediji', 'Sport', 'Studentska sekcija', 'Poster-prezentacije'],
        indexing_label: 'Indeksiranost SEEJC',
        indexing: ['EBSCO', 'ERIH Plus', 'CEEOL', 'Hrčak'],

        call_title: 'Poziv za sudjelovanje',
        topics_title: 'Tematski okviri',
        topics_note: 'Dobrodošli su i prijedlozi radova koji nisu izravno navedeni među tematskim okvirima, ali se sadržajno uklapaju u područja odnosa s javnošću, medija, organizacije, upravljanja, komunikacije i sporta.',
        topics: [
            'Odnosi s javnošću u kontekstu četvrte industrijske revolucije',
            'Digitalna transformacija organizacija i komunikacijskih procesa',
            'Umjetna inteligencija u odnosima s javnošću, medijima i sportu',
            'Organizacijska komunikacija u digitalnom radnom okruženju',
            'Strateško komuniciranje i upravljanje organizacijskim promjenama',
            'Upravljanje informacijama i donošenje odluka u digitalnom dobu',
            'Automatizacija i personalizacija komunikacijskih procesa',
            'Analitika podataka u odnosima s javnošću i strateškoj komunikaciji',
            'Upravljanje reputacijom u digitalnom komunikacijskom okruženju',
            'Krizno komuniciranje u uvjetima ubrzanih tehnoloških promjena',
            'Digitalni identitet i strateško pozicioniranje organizacija',
            'Integrirana komunikacija i upravljanje komunikacijskim kanalima',
            'Novi medijski formati i transformacija medijskih organizacija',
            'Društvene mreže, digitalne platforme i promjene ponašanja publike',
            'Dezinformacije, vjerodostojnost medija i povjerenje javnosti',
            'Etički izazovi primjene umjetne inteligencije u komunikaciji',
            'Digitalna komunikacija u sportskim organizacijama',
            'Upravljanje sportskim brendovima i odnosima s navijačima',
            'Primjena novih tehnologija u sportskom menadžmentu i komunikaciji',
            'Obrazovanje komunikacijskih stručnjaka za potrebe organizacija 4.0',
        ],
        abstract_title: 'Upute za izradu sažetka',
        abstract_format: [
            'Opseg sažetka: najviše 250 riječi',
            'Format dokumenta: Microsoft Word',
            'Font: Times New Roman, veličina 11',
            'Prored: 1,5',
            'Margine: 2,5 cm',
            'Jezik sažetka: hrvatski i engleski',
            'Broj ključnih riječi: najviše pet',
        ],
        abstract_contents_label: 'Sažetak treba sadržavati:',
        abstract_contents: [
            'naslov rada',
            'kratak opis teme i problema rada',
            'cilj rada',
            'korišteni istraživački ili teorijski pristup',
            'najvažnije rezultate ili očekivani doprinos rada',
            'najviše pet ključnih riječi',
            'ime i prezime autora, naziv matične ustanove i adresu elektroničke pošte',
        ],
        abstract_send: 'Prijave i sažetke radova potrebno je poslati na službenu adresu elektroničke pošte Konferencije:',
        publication_title: 'Objava radova',
        publication_text: 'Sudionici Konferencije imaju mogućnost prijaviti cjelovite radove za objavu u znanstvenom časopisu South Eastern European Journal of Communication. Prijavljeni radovi razmatrat će se za objavu nakon provedenoga uredničkog i recenzentskog postupka te njihova usklađivanja s uputama časopisa.',
        publication_link: 'Upute autorima časopisa SEEJC',

        committee_title: 'Organizacijski odbor',
        secretary_title: 'Tajnik konferencije',
        roles: {
            founder: 'utemeljitelj i počasni predsjednik konferencije',
            president: 'Predsjednik Organizacijskog odbora',
            member: 'član',
            secretary: 'Tajnik Konferencije',
        },
        institutions: {
            mostar: 'Sveučilište u Mostaru',
            dubrovnik: 'Sveučilište u Dubrovniku',
            sjever: 'Sveučilište Sjever',
            sjever_alma: 'Sveučilište Sjever, Alma Mater Europea University',
            zagreb_split: 'Katoličko Sveučilište u Zagrebu, Sveučilište u Splitu',
            beograd: 'Univerzitet u Beogradu',
            sapir: 'Sapir College Israel',
            fifa: 'odvjetnik i član FIFA Nogometnog Tribunala',
        },
        speakers_soon: 'Predavači jedanaestog izdanja bit će objavljeni uskoro.',
        editions_title: 'Dosadašnja izdanja',
        edition_label: 'izdanje',
        sponsors: 'Sponzori',
        media_partners: 'Medijski partneri',
        gallery: 'Galerija',
        read_more: 'Pročitaj više',
        read_less: 'Prikaži manje',
        email_label: 'E-adresa',
        web_label: 'Mrežna stranica',
        phone_label: 'Telefon',
        address_label: 'Adresa',
        address: 'Filozofski fakultet Sveučilišta u Mostaru, Matice hrvatske b. b., 88000 Mostar, BiH',
        back_to_top: 'Povratak na vrh',
        no_blogs: 'Trenutno nema objavljenih blogova.',
        related_blogs: 'Još s bloga',
        related_news: 'Još novosti',
        views: 'pregleda',
    },
    en: {
        eyebrow: 'Eleventh edition · Mostar',
        conference_type: 'International scientific and professional conference',
        date: '11–13 November 2026',
        date_short: '11–13 Nov 2026',
        theme_label: 'Conference theme',
        theme: 'PR 4.0 – Organisation, Management and Communication',
        theme_short: 'Organisation, Management and Communication',
        intro: 'Organised by the Department of Public Relations and the Department of Journalism of the Faculty of Humanities and Social Sciences, University of Mostar, the eleventh edition of the international scientific and professional conference “PR, Media & Sports Days University of Mostar” will be held from 11 to 13 November 2026.',
        focus: 'Special emphasis is placed on an interdisciplinary approach to communication as a strategic resource for organising, managing and leading organisations, media, public institutions, business systems and sports organisations in today’s digital, global and interconnected environment.',
        calendar_google: 'Add to Google Calendar',
        calendar_details: 'Eleventh edition of the international scientific and professional conference. Theme: PR 4.0 – Organisation, Management and Communication. More information: https://prdays.sum.ba',
        countdown_title: 'Conference starts in',
        countdown_units: ['Days', 'Hours', 'Minutes', 'Seconds'],
        countdown_live: 'The conference is under way!',
        countdown_done: 'Thank you all for taking part!',
        program_download: 'Download the conference programme',
        program_soon: 'The conference programme will be published soon.',
        call_download: 'Call for papers (PDF, Croatian)',
        send_abstract: 'Submit an abstract',

        dates_title: 'Key dates',
        dates_groups: [
            {
                title: 'Presentation submissions',
                items: [
                    {date: '19 October 2026', label: 'Abstract submission deadline'},
                    {date: '26 October 2026', label: 'Notification of acceptance'},
                    {date: '2 November 2026', label: 'PowerPoint presentation deadline'},
                    {date: '11–13 November 2026', label: 'Conference', highlight: true},
                ],
            },
            {
                title: 'Full papers (SEEJC)',
                items: [
                    {date: '26 October 2026', label: 'Full paper submission deadline'},
                    {date: '15 November 2026', label: 'Notification of full paper acceptance'},
                ],
            },
        ],

        facts_title: 'Conference at a glance',
        facts: [
            {icon: 'mdi-numeric', label: 'Edition', value: 'Eleventh edition'},
            {icon: 'mdi-translate', label: 'Working languages', value: 'Croatian and English'},
            {icon: 'mdi-timer-outline', label: 'Oral presentation length', value: 'Up to 15 minutes'},
            {icon: 'mdi-email-outline', label: 'Applications and abstracts', value: 'prdays@ff.sum.ba', href: 'mailto:prdays@ff.sum.ba'},
            {icon: 'mdi-web', label: 'Website', value: 'prdays.sum.ba', href: 'https://prdays.sum.ba'},
            {icon: 'mdi-book-open-page-variant-outline', label: 'Full paper publication', value: 'South Eastern European Journal of Communication (SEEJC)', href: 'https://seejc.sum.ba'},
        ],
        sections_label: 'Programme / sections',
        sections: ['Public relations', 'Media', 'Sport', 'Student section', 'Poster presentations'],
        indexing_label: 'SEEJC is indexed in',
        indexing: ['EBSCO', 'ERIH Plus', 'CEEOL', 'Hrčak'],

        call_title: 'Call for papers',
        topics_title: 'Thematic areas',
        topics_note: 'Proposals not directly listed among the thematic areas are also welcome, provided they fit the fields of public relations, media, organisation, management, communication and sport.',
        topics: [
            'Public relations in the context of the Fourth Industrial Revolution',
            'Digital transformation of organisations and communication processes',
            'Artificial intelligence in public relations, media and sport',
            'Organisational communication in the digital workplace',
            'Strategic communication and management of organisational change',
            'Information management and decision-making in the digital age',
            'Automation and personalisation of communication processes',
            'Data analytics in public relations and strategic communication',
            'Reputation management in the digital communication environment',
            'Crisis communication amid rapid technological change',
            'Digital identity and strategic positioning of organisations',
            'Integrated communication and communication channel management',
            'New media formats and the transformation of media organisations',
            'Social networks, digital platforms and changing audience behaviour',
            'Disinformation, media credibility and public trust',
            'Ethical challenges of applying artificial intelligence in communication',
            'Digital communication in sports organisations',
            'Managing sports brands and fan relations',
            'Applying new technologies in sports management and communication',
            'Educating communication professionals for Organisation 4.0',
        ],
        abstract_title: 'Abstract guidelines',
        abstract_format: [
            'Length: up to 250 words',
            'Document format: Microsoft Word',
            'Font: Times New Roman, size 11',
            'Line spacing: 1.5',
            'Margins: 2.5 cm',
            'Abstract language: Croatian and English',
            'Keywords: up to five',
        ],
        abstract_contents_label: 'The abstract should include:',
        abstract_contents: [
            'title of the paper',
            'a brief description of the topic and research problem',
            'aim of the paper',
            'research or theoretical approach used',
            'main results or expected contribution',
            'up to five keywords',
            'author’s full name, home institution and e-mail address',
        ],
        abstract_send: 'Applications and abstracts should be sent to the official conference e-mail address:',
        publication_title: 'Publication',
        publication_text: 'Conference participants may submit full papers for publication in the scientific journal South Eastern European Journal of Communication. Submitted papers will be considered for publication after editorial and peer review and alignment with the journal’s guidelines.',
        publication_link: 'SEEJC author guidelines',

        committee_title: 'Organising Committee',
        secretary_title: 'Conference Secretary',
        roles: {
            founder: 'founder and honorary president of the conference',
            president: 'President of the Organising Committee',
            member: 'member',
            secretary: 'Conference Secretary',
        },
        institutions: {
            mostar: 'University of Mostar',
            dubrovnik: 'University of Dubrovnik',
            sjever: 'University North',
            sjever_alma: 'University North, Alma Mater Europaea University',
            zagreb_split: 'Catholic University of Croatia, University of Split',
            beograd: 'University of Belgrade',
            sapir: 'Sapir College Israel',
            fifa: 'attorney and member of the FIFA Football Tribunal',
        },
        speakers_soon: 'Speakers of the eleventh edition will be announced soon.',
        editions_title: 'Previous editions',
        edition_label: 'edition',
        sponsors: 'Sponsors',
        media_partners: 'Media partners',
        gallery: 'Gallery',
        read_more: 'Read more',
        read_less: 'Show less',
        email_label: 'E-mail',
        web_label: 'Website',
        phone_label: 'Telephone',
        address_label: 'Address',
        address: 'Faculty of Humanities and Social Sciences, University of Mostar, Matice hrvatske b. b., 88000 Mostar, Bosnia and Herzegovina',
        back_to_top: 'Back to top',
        no_blogs: 'There are no blog posts yet.',
        related_blogs: 'More from the blog',
        related_news: 'More news',
        views: 'views',
    },
};
